import { AssetBreakdownKind } from 'models'
import { EM_DASH, sanitizeAssetValue } from 'lib/sanitizeAssetValue'

/* Values arrive lowercase, the spelling the filters match on; only what is shown prettifies them. */
const KIND_LABELS: Partial<Record<AssetBreakdownKind, string>> = {
  [AssetBreakdownKind.NoValue]: 'No value',
  [AssetBreakdownKind.Other]: 'Other'
}

/**
 * Shared so a bar and the chip its click leaves behind cannot read differently. A bar's label is a
 * customer value like any other cell, so it is sanitized here, where it enters the UI.
 */
export const bucketLabel = (label: string, kind: AssetBreakdownKind): string => {
  const known = KIND_LABELS[kind]

  if (known) return known

  const value = sanitizeAssetValue(label)

  return value ? value.charAt(0).toUpperCase() + value.slice(1) : EM_DASH
}
